// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
require("@rails/activestorage").start();
require("channels");

import "./plugins/hotwired";
// Emit events trough window object
import EventEmitter from "events";
window.emitter = new EventEmitter();
import * as bootstrap from "bootstrap";

import jquery from "jquery";
// Makes it usable in views
window.$ = jquery;
// Required for bootstrap v5. Some places still use with jquery like in bootstrap v3/v4
window.jQuery = jquery;
window.bootstrapModal = bootstrap.Modal;
import axios from "axios";

require("@nathanvda/cocoon");

//import "./themeMode.js";

import "./plugins/datepicker";
import "./plugins/dayjs";
import "./plugins/datepicker";
import "./plugins/select2";
import hugerte from "hugerte";

import { removeVisibleTooltips, setupJavascript, initTooltips } from "./setup";

document.addEventListener("turbo:visit", () => {
  document.body.classList.add("cursor-loading");
});

document.addEventListener("turbo:before-cache", () => {
  removeVisibleTooltips();
  hugerte.remove(); // remove or else it will not init again
  const toasts = document.querySelector("#toasts");
  if (toasts.childElementCount) {
    toasts.childNodes.forEach(el => el.remove());
  }
});

document.addEventListener("turbo:load", () => {
  document.body.classList.remove("cursor-loading");

  const token = document.getElementsByName("csrf-token");
  if (token && token[0]?.content) {
    axios.defaults.headers.common["X-CSRF-Token"] = token[0].content;
    axios.defaults.headers.common["Accept"] = "application/json;charset=UTF-8";
  }
});

document.addEventListener("turbo:before-frame-render", () => {
  setTimeout(() => {
    setupJavascript();
  }, 100);
});

document.addEventListener("turbo:frame-load", () => {
  window.scrollBy(0, -72);
});

document.addEventListener("turbo:submit-end", e => {
  // Reinit tooltips
  hugerte.remove(); // remove or else it will not init again
  removeVisibleTooltips();
  initTooltips();

  // Do not scroll if form is inside modal, triggered by shadow form or form with button_to class
  // Shadow form as in rails ujs/turbo confirm is used on <a> and clicking it creates new one
  if (
    !(
      e.target.hidden || // When its link but has data-turbo-method="post" which creates seperate form action
      e.target.closest("#modal") || // When its inside modal or confirmation variant for turbo
      e.target.closest("#modalTurbo") ||
      e.detail.formSubmission.formElement.style.display ==
        "none" /* Shadow form is hidden*/ ||
      e.detail.formSubmission.formElement.classList.contains("button_to")
    )
  ) {
    document.querySelector("main.container").scrollIntoView();
    window.scroll(0, -50);
  }

  // This custom event needs to be manually attached trough stimulus and not trough data-action because
  // stimulus doesn't support custom events
  e.detail.formSubmission.formElement.dispatchEvent(
    new CustomEvent("form:submit-end", { detail: e.detail })
  );

  setTimeout(() => {
    setupJavascript();
  }, 100);
});
